var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560",
      "content-class": "ma-0 pa-0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-card-title', {
    staticClass: "pa-16"
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "placeholder": "이름 또는 아이디를 입력해주세요."
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "priamry"
          }
        }, [_vm._v("검색하기")])];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    staticClass: "px-16 pt-0 pb-16"
  }, [_vm._v(" 이름 검색은 내 공공에 지원한 사용자나 인력풀에서만 검색됩니다."), _c('br'), _vm._v(" 내 정보에 없는 사용자 선택시 이름 또는 전화번호, 이메일을 정확이 입력해야합니다. ")]), _c('div', {
    staticClass: "px-16 pt-0 pb-16"
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item._id,
      staticClass: "pa-8",
      attrs: {
        "cols": "12"
      }
    }, [_c('room-participants-push-item', _vm._b({}, 'room-participants-push-item', {
      item,
      selected: _vm.selected
    }, false))], 1)];
  })], 2)], 1), _c('div', {
    staticClass: "px-16 pt-0 pb-16"
  }, [_c('v-row', {
    staticClass: "ma-n8"
  }, [_c('v-col', {
    staticClass: "pa-8"
  }, [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" 취소하기 ")])], 1), _c('v-col', {
    staticClass: "pa-8"
  }, [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.push
    }
  }, [_vm._v(" 추가하기 ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }